import { Component, Input } from '@angular/core';
import {ObjectsService} from "@app/_services";

@Component({
  selector: 'cards-item-news',
  templateUrl: './cards-item-news.component.html',
  styleUrls: ['./cards-item-news.component.scss']
})
export class CardsItemNewsComponent {
  @Input() card: any;

  constructor(private objectsService: ObjectsService) {
  }

  get image() {
    return this.objectsService.getValue(this.card, 'image')?.links?.open;
  }

  get linkTitle() {
    return this.objectsService.getValue(this.card, 'button-title-non-required');
  }

  get link() {
    return this.objectsService.getValue(this.card, 'button-url-non-required');
  }

  get text() {
    return this.objectsService.getValue(this.card, 'text');
  }

  get documents() {
    return this.objectsService.getValue(this.card, 'documents');
  }

  get html() {
    return this.objectsService.getValue(this.card, 'html-required');
  }

  ngOnInit(){
  }


}
